<template>
  <div class="layout-mood-blue-content" id="identidade-visual-mood-blue" data-search-anchor>
    <div class="descriptiom-layout-mood-blue-wrapper">
      <div class="icon-wrapper">
        <IconCheck />
        <p class="layout-mood-blue-description">{{ layoutMoodBlueDescription1 }}</p>
      </div>
    </div>
    <div
      class="layout-mood-blue-card-item"
      :style="{ backgroundImage: `url(${layoutMoodBlueImageSrc})` }"
    ></div>
  </div>
</template>

<script lang="ts">
import IconCheck from '@/assets/icons/IconCheck.vue'
import { PageStoreContract } from '@/data/store/page.store.contract'
import LayoutPageMixin from '@/mixins/layout-page-mixin'
import { LayoutPageStore } from '@/store/visual-identity-page/layout-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({ components: { IconCheck } })
export default class LayoutsMoodBlueSection extends Mixins(LayoutPageMixin) {
  layoutPageStore: PageStoreContract = getModule(LayoutPageStore, this.$store)

  get layoutMoodBlueDescription1(): string {
    return this.getElementText(14, 0)
  }

  get layoutMoodBlueImageSrc(): string {
    return this.getElementMedia(14, 1)
  }

  async getLayoutPage(): Promise<void> {
    await this.layoutPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.layoutPageStore.isLoading) {
      await this.getLayoutPage()
    }
  }
}
</script>

<style lang="scss">
.layout-mood-blue-content {
  display: grid;

  width: 100%;
  max-width: 1032px;
}

.descriptiom-layout-mood-blue-wrapper {
  padding: 2rem 0rem 0rem 0rem;
  position: relative;

  display: grid;
  grid-template-columns: 50% 50%;  
}

.layout-mood-blue-description {
  font-size: 25px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;

  padding-left: 7px;
  width: 374px;
}

.layout-mood-blue-card-item {
  position: relative;
  
  max-width: 1032px;
  width: 100%;
  height: 705px;

  background-repeat: no-repeat;
  background-size: contain;
}
</style>
